<template>
  <div v-if="hasTimeLimitOption && !$store.state.presentation.audiencePacing">
    <div class="settings-content__wrapper relative">
      <div
        class="absolute top-0 left-0 w-full h-full z-10 cursor-pointer"
        v-if="planBenefit.interactivePresentation &&
          !planBenefit.interactivePresentation.advancedSubmissionControls"
        @click="handleCheckNeedUpgradePlan()"
      >
      </div>
      <div class="horizontal layout center">
        <aha-icon name="stopwatch" class="settings-icon mb-0.5"></aha-icon>
        <span class="px-1 font-normal">{{ $i18nPresenter.t('Time limit') }}</span>
        <IconNeedUpgradePlan
          v-if="planBenefit.interactivePresentation"
          ref="iconNeedUpgradePlanComponenTimeLimit"
          :noPermission="planBenefit.interactivePresentation &&
            !planBenefit.interactivePresentation.advancedSubmissionControls"
          :defaultTooltip="$i18nPresenter.t(
            'Choose the maximum time in which players can answer')"
          left="-80px"
          :upgradePlan="planBenefit.interactivePresentation.advancedSubmissionControls_planName"
          featureName="Lock Submissions"
        />
      </div>
      <div class="time-toggle-wrapper">
        <TimeToAnswerConfig class="mr-3 time-toggle" :class="{ 'show': slideActive.hasTimeLimit }" />
        <span v-tooltip="timeLimitTooltip">
          <toggle-button
            :width="35"
            :height="20"
            class="mb-0"
            @change="updateTimeLimit()"
            v-model="slideActive.hasTimeLimit"
            :color="{ checked: '#348EF6', unchecked: '#D3D7E1', disabled: '#D3D7E1' }"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import * as Sentry from '@sentry/vue'
import { mapState, mapActions } from 'vuex'
import Config from '@/config'
import Util from '@/util'
import TimeToAnswerConfig from '@/components-v2/presentation-editor/side-right/TimeToAnswerConfig.vue'
import Socket from '@/socket'
import IconNeedUpgradePlan from '@/components-v2/my-plan/IconNeedUpgradePlan.vue'

export default {
  components: {
    TimeToAnswerConfig,
    IconNeedUpgradePlan,
  },
  data() {
    return {
      updateTimeLimitDebounce: null,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      slideActive: (state) => state.slideActive,
      planBenefit: (state) => state.planBenefit,
    }),
    hasTimeLimitOption() {
      return this.slideActive.type === 'imageChoice' ||
        this.slideActive.type === 'multipleChoice' ||
        this.slideActive.type === 'openEnded' ||
        this.slideActive.type === 'wordCloud' ||
        this.slideActive.type === 'scale'
    },
    isInAudiencePacing() {
      return JSON.parse(this.$store.state.presentation.audiencePacing)
    },
    timeLimitTooltip() {
      return this.$i18nPresenter.t('Choose the maximum time in which players can answer')
    },
  },
  mounted() {
    this.updateTimeLimitDebounce = _.debounce(this.updateTimeLimit, 1000)
  },
  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSyncPresentationAction']),
    async updateTimeLimit() {
      let timeToAnswer = Math.max(5, this.slideActive.timeToAnswer)
      timeToAnswer = Math.min(1200, timeToAnswer)

      const data = {
        timeToAnswer,
        hasTimeLimit: this.slideActive.hasTimeLimit,
      }

      this.setSyncPresentationAction(1)
      this.updateSlideActiveAction(data)

      data.socketId = Socket.getSocketId()
      data.accessCode = this.$store.state.presentation.uniqueAccessCode
      data.presentationId = this.$store.state.presentation.id
      data.presenting = this.$store.getters.isPresenting

      try {
        await this.$http.put(Config.api.updateSlide + this.slideActive.id, data)

        this.setSyncPresentationAction(2)
        Util.mixpanelTracking(
          'Slide update',
          `${data.hasTimeLimit ? 'enable' : 'disable'} time limit`,
          data.timeToAnswer,
        )
      } catch (error) {
        Sentry.captureException(error)
        this.setSyncPresentationAction(3)
      }
    },
    handleCheckNeedUpgradePlan() {
      if (this.planBenefit.interactivePresentation &&
        !this.planBenefit.interactivePresentation.advancedSubmissionControls) {
        this.$refs.iconNeedUpgradePlanComponenTimeLimit.toggleTooltip()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss-v2/variables.scss";
.label-time-limit {
  position: absolute;
  top: 43px;
  left: 111px;
}

.custom-control-label {
  cursor: pointer;
}
.settings-content__wrapper {
  @apply flex items-center justify-between;
  @apply py-4;
  @apply border-t border-base-30;
  &:hover {
    .title-table-presentation-tooltip {
      opacity: 1;
    }
    &.general-quiz-settings {
      @apply text-primary-100;
      .settings-icon,
      .settings-icon__arrow {
        @apply text-primary-100;
      }
    }
  }
  &.sub-content {
    margin-left: 1.75rem;
    border-top: none;
    padding-top: 0;
  }
  &.general-quiz-settings {
    @apply cursor-pointer;
    .settings-icon__arrow {
      @apply text-secondary-40;
    }
  }
  .settings-icon {
    color: $secondary-60-color;
  }
  .settings-content__link {
    color: inherit;
    text-decoration: underline;
  }
  .title-table-presentation-tooltip {
    opacity: 0;
    transition: all 0.2s ease-in-out;
  }
}
.time-toggle-wrapper {
  display: inherit;
  align-items: inherit;
  .time-toggle {
    visibility: hidden;
    &.show {
      visibility: visible;
    }
  }
}
</style>
